import React, { Fragment, useEffect, useState } from 'react';
//import { useNavigate } from "react-router-dom";
//import { UserContext } from "../UserContext";
//import { hasAnyPerm } from '../utils/uiUtils';
import { Button, Card, Row, Col, Form, Modal, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { BiCalendar, BiCheck, BiDownload, BiTrash, BiXCircle } from "react-icons/bi";
import { AlertFillIcon, SearchIcon } from '@primer/octicons-react';
import DateTimePicker from 'react-datetime-picker';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_EGRESS_DATA_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import configInfo from '../config/config.json';
import { formatDate } from '../utils/timeUtils';
import { translateAPIError } from '../utils/apiUtils';
import classes from './AdminPages.module.css';


const DataInspectAdmin = () => {

  //const { user } = useContext(UserContext);
  //const navigate = useNavigate();

  const { i18n, t } = useTranslation(["common"]);

  const [errMsgDpSelectDlg,  setErrMsgDpSelectDlg]    = useState('');

  const [dataFetchAttrs,     setDataFetchAttrs]       = useState({
                                                          startTime: null,
                                                          endTime: null,
                                                          datapoints: null,
                                                        });

  const [showDpSelectDialog, setShowDpSelectDialog]   = useState(false);
  const [selectedDpList,     setSelectedDpList]       = useState([]);
  const [datapointList,      setDatapointList]        = useState([]);
  const [dpSearchTerms,      setDpSearchTerms]        = useState('');

  const [datapointDataRaw,   setDatapointDataRaw]     = useState([]);
  const [datapointData,      setDatapointData]        = useState([]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
/*
    if (!hasAnyPerm(user, ["SystemAdminFullAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }
*/

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  function handleDpSelect() {
    setShowDpSelectDialog(true);
    setDpSearchTerms('');
    setErrMsgDpSelectDlg('');
  }


  function handleExportData() {

    // Prepare header fields
    let headers = ["Timestamp","Epoch time"];
    for (let i=0; i<datapointDataRaw.length; i++) {
      headers.push(datapointDataRaw[i].datapoint);
    }

    let currentDate = new Date();
    let fileName = "DatapointInspect_" + currentDate.toISOString().split("T")[0] + "_" +
                   currentDate.toLocaleTimeString().replaceAll(':','-').replaceAll(' ','');
    downloadCSV(headers, datapointData, fileName);
  }


  function handleClearData() {
    setDataFetchAttrs({ startTime: null,
                        endTime: null,
                        datapoints: null,
                      });
    setSelectedDpList([]);
    setDatapointList([]);
    setDpSearchTerms('');
    setDatapointDataRaw([]);
    setDatapointData([]);
  }


  const onDatepickerChangeStartTime = (value) => {
    setDataFetchAttrs({ ...dataFetchAttrs, startTime: value })
  }

  const onDatepickerChangeEndTime = (value) => {
    setDataFetchAttrs({ ...dataFetchAttrs, endTime: value })
  }


  function handleDpAdd(datapoint) {

    if (selectedDpList && selectedDpList.length === 5) {
      setErrMsgDpSelectDlg(t("I18N_ERR_Max_item_cnt_reached") + 5);
    } else if (selectedDpList && (selectedDpList.find( ({ code }) => code === datapoint.code) != null)) {
      setErrMsgDpSelectDlg(t("I18N_ERR_Dp_already_sel"));
    } else {
      let tempSelectDpList = JSON.parse (JSON.stringify(selectedDpList));

      tempSelectDpList.push(datapoint);

      setSelectedDpList(tempSelectDpList);
      setErrMsgDpSelectDlg('');
    }
  }


  const handleDpSearch = (e) => {
    e.preventDefault();

    if (dpSearchTerms === '') {
      setDpSearchTerms('');
      setDatapointList([]);
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        // ##### A temp hack to limit the amount of data returned.  If unckecked, may cause performance issues or blow up service. #####
        const res = await axiosAuth_DATA_MGMT_API.get("datapoints?searchTerms=" + dpSearchTerms + "&limit=100&offset=0");

        resolve(res.data);

        if (res.status === 200) {
          setDatapointList(res.data.data);
        }

        setErrMsgDpSelectDlg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsgDpSelectDlg(t(translateAPIError(error)));
        }
      }
    });
  }


  function renderDatapoint(datapoint, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "40%"}}>{datapoint.code}</td>
        <td style={{width: "40%"}}>{datapoint.description}</td>
        <td style={{width: "20%"}}>
          <Button size="tiny" variant="outline-secondary" style={{ float: 'left' }} onClick={() => handleDpAdd(datapoint)}>
            {t("I18N_Select")}
          </Button>
       </td>
      </tr>
    )
  }


  const onDpSearchInputChange = (e) => {
    setDpSearchTerms(e.target.value);
  }



  function renderSelectedDp(datapoint, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "40%"}}>{datapoint.code}</td>
        <td style={{width: "40%"}}>{datapoint.description}</td>
        <td style={{width: "20%"}}>
          <OverlayTrigger overlay={<Tooltip id="tooltip-del_dp" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_datapoint")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRemoveDp(datapoint)}><BiTrash size={16} /></span>
          </OverlayTrigger>
       </td>
      </tr>
    )
  }


  function handleRemoveDp(datapoint) {

    // Deep copy
    let tmpList = JSON.parse (JSON.stringify(selectedDpList));

    let index = tmpList.indexOf(tmpList.find( ({ code }) => code === datapoint.code));

    if(index !== -1) {
      tmpList.splice(index, 1);
      setSelectedDpList(tmpList);
    }
  }

  function renderData(data, index) {

    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>{formatDate(data.time)}</td>
        <td>{data.timestamp}</td>
        { datapointDataRaw && datapointDataRaw[0] ? <td>{data.data_0}</td> : null }
        { datapointDataRaw && datapointDataRaw[1] ? <td>{data.data_1}</td> : null }
        { datapointDataRaw && datapointDataRaw[2] ? <td>{data.data_2}</td> : null }
        { datapointDataRaw && datapointDataRaw[3] ? <td>{data.data_3}</td> : null }
        { datapointDataRaw && datapointDataRaw[4] ? <td>{data.data_4}</td> : null }
       {configInfo.appConfig.checkDataIntegrity  ?
        <td style={{width: "20%"}}>
          {datapointDataRaw && datapointDataRaw[0] && data.data_0 ?
            <span>
              <Button size="tiny" variant="outline-secondary" style={{ float: 'left' }} onClick={() => handleCheckIntegrity(index, datapointList[0].id, data.timestamp_0)}>
                {t("I18N_Check_integrity")}
              </Button>
              { data.integrityCheck ?
              <span style={{marginLeft:'5px', color:'green'}}>
                <BiCheck size={18} /> {t("I18N_Integrity_check_success")}
              </span>
              : ("integrityCheck" in data) && !data.integrityCheck ?
              <span style={{marginLeft:'6px', marginTop:'3px', fontSize:'11px', fontWeight:'500', color:'red'}}>
                <AlertFillIcon size={16} /> {t("I18N_Integrity_check_failed")}
              </span>
              : null
              }
            </span>
          : null
          }
       </td>
       : null
       }
      </tr>
    )
  }


  function handleFetchDataCancel() {
    setShowDpSelectDialog(false);
    setErrMsgDpSelectDlg('');
  }


  function handleFetchDataSubmit() {

    // Validation
    if (!dataFetchAttrs.startTime) {
      setErrMsgDpSelectDlg(t("I18N_ERR_Need_start_time"));
      return;
    } else if (!dataFetchAttrs.endTime) {
      setErrMsgDpSelectDlg(t("I18N_ERR_Need_end_time"));
      return;
    } else if (dataFetchAttrs.endTime <= dataFetchAttrs.startTime) {
      setErrMsgDpSelectDlg(t("I18N_ERR_End_time_LE_Start_time"));
      return;
    } else if ((dataFetchAttrs.endTime.getTime() - dataFetchAttrs.startTime.getTime()) > 24*60*60*1000) {
      setErrMsgDpSelectDlg(t("I18N_ERR_Max_time_span_exceeded") + "24 " + t("I18N_Time_unit_h"));
      return;
    } else if (!selectedDpList || (selectedDpList.length === 0)) {
      setErrMsgDpSelectDlg(t("I18N_ERR_Need_datapoint"));
      return;
    }

    // Adjust start and end time to compansate the case where raw data timestamp does not fall on the exact minute boundary
    let tmpStartTime = new Date(dataFetchAttrs.startTime);
    let tmpEndTime   = new Date(dataFetchAttrs.endTime);
    tmpStartTime.setSeconds(tmpStartTime.getSeconds() - 30.0);
    tmpEndTime.setSeconds(tmpEndTime.getSeconds()     + 30.0);

    let reqBody = {};
    reqBody.startTime = JSON.parse(JSON.stringify(tmpStartTime));
    reqBody.endTime   = JSON.parse(JSON.stringify(tmpEndTime));

    reqBody.datapoints = [];
    for (let i=0; i<selectedDpList.length; i++) {
      reqBody.datapoints.push(selectedDpList[i].code);
    }

/*
    reqBody.window = "1m";
    reqBody.fn = "mean";
*/


    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_EGRESS_DATA_API.post("data-history-batch", reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Loop through each time node (E.g. every minute), then fetch from the raw data the value closest to the node time.
          let timeSpan = 60.0;  // In second.  ### This may change from customer to customer, need to be configurable. ###
          let tmpDataList = [];
          let startTimestamp = dataFetchAttrs.startTime.getTime()/1000;
          let endTimestamp   = dataFetchAttrs.endTime.getTime()/1000;

          let count = Math.ceil((endTimestamp - startTimestamp) / timeSpan);

          for (let i=0; i<count+1; i++) {
             tmpDataList[i] = {};
             tmpDataList[i].timestamp = startTimestamp + i * timeSpan;
             let d = new Date(0);
             tmpDataList[i].time = d.setUTCSeconds(tmpDataList[i].timestamp);
          }

          // Loop through each datapoint
          for (let i=0; i<res.data.length; i++) {

            // Loop through all the values (dataElements) of that datapoint
            for (let j=0; j<res.data[i].dataElements.length; j++) {

              let roundedTimestamp = (Math.round(res.data[i].dataElements[j].timestamp / 60.0)) * 60;

              // Insert the value to the master list node with the matching timestamp.  Discard, if not found.
              let index = tmpDataList.indexOf(tmpDataList.find( ({ timestamp }) => timestamp === roundedTimestamp));

              if (index >= 0) {
                tmpDataList[index]["data_" + i] = res.data[i].dataElements[j].value;
                tmpDataList[index]["timestamp_" + i] = res.data[i].dataElements[j].timestamp;
              }
            }
          }

          setDatapointDataRaw(res.data);
          setDatapointData(tmpDataList);
        }

        setErrMsgDpSelectDlg('');
        setShowDpSelectDialog(false);
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsgDpSelectDlg(t(translateAPIError(error)));
        }
     }
    });
  }

  function handleCheckIntegrity(index, datapointId, timestamp) {

/*
let tmp = JSON.parse (JSON.stringify(datapointData));
tmp[index].integrityCheck = true;
setDatapointData(tmp)
*/

    let reqBody = {
          datapointId: datapointId,
          timestamp:   timestamp
        }

    return new Promise(async (resolve, reject) => {

      try {
        const res = await axiosAuth_EGRESS_DATA_API.post("datapoints/hmac-check", reqBody);

        resolve(res.data);

        let tmp = JSON.parse (JSON.stringify(datapointData));

        if (res.status === 200) {

          if (res.data.msg === 'success') {
            tmp[index].integrityCheck = true;
          } else {
            tmp[index].integrityCheck = false;
          }
        } else {
          tmp[index].integrityCheck = false;
        }

        setDatapointData(tmp)

      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsgDpSelectDlg(t(translateAPIError(error)));
        }
      }
    });
  }

  const downloadCSV = (headerFields, data, fileName) => {
    // Convert the data array into a CSV string

    const csvString = [
      headerFields, // Specify your headers here
      ...data.map(item => [JSON.stringify(formatDate(item.time)), item.timestamp,item.data_0, item.data_1, item.data_2, item.data_3, item.data_4
                          ]) // Map your data fields accordingly
    ]
    .map(row => row.join(","))
    .join("\n");

    // Create a Blob from the CSV string
    const blob = new Blob([csvString], { type: 'text/csv' });

    // Generate a download link and initiate the download
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || 'download.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };


  // ----- BEGIN UI -----

  return (
    <Fragment>
      <Card className='aaa' style={{border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)', padding:'20px 40px 20px 40px', maxWidth:'2500px', height:'850px', width:'100%'}}>
        <div style={{ display: 'flex' }}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_Data_Inspection")}
          </span>

          <div style={{ display: 'flex', marginLeft: 'auto', marginRight: '0px', width: '250px', minWidth: '250px' }}>
            <OverlayTrigger overlay={<Tooltip id="tooltip-del_dp" style={{fontSize:'11px'}}>{t("I18N_TIP_Download")}</Tooltip>}>
              { datapointData && (datapointData.length > 0) ?
                <span style={{marginLeft:'auto', cursor:'pointer', color:'gray'}} onClick={() => handleExportData()}><BiDownload size={16} /></span>
              :
                <span style={{marginLeft:'auto', color:'gray'}} disabled={true} ><BiDownload size={16} /></span>
              }
            </OverlayTrigger>

            <OverlayTrigger overlay={<Tooltip id="tooltip-del_dp" style={{fontSize:'11px'}}>{t("I18N_TIP_Clear")}</Tooltip>}>
              <span style={{marginLeft:'10px', cursor:'pointer', color:'gray'}} onClick={() => handleClearData()}><BiXCircle size={16} /></span>
            </OverlayTrigger>

            <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ marginLeft:'20px', marginRight:'0px', float: 'right' }}
              onClick={handleDpSelect}>
              {t("I18N_Fetch_data")}
            </Button>

          </div>
        </div>

        { (!datapointData || datapointData.length === 0) ?
          <span className={classes.admin_pages__field_value} style={{marginTop:'20px'}}>
            {t("I18N_No_data")}
          </span>
        :
          <div style={{ overflowY:'auto', fontSize:'11px', marginTop:'10px' }}>
            <Table hover size="sm">
              <thead style={{ position:'sticky', top:'0', color:'#686868', fontSize:'12px', borderBottom:'2px solid #D0D0D0' }}>
                <tr>
                  <th style={{width:'15%', fontWeight:'400'}}>{t("I18N_Timestamp")}</th>
                  <th style={{width:'15%', fontWeight:'400'}}>{t("I18N_Epoch_time")}</th>
                  { datapointDataRaw && datapointDataRaw[0] ?
                    <th style={{fontWeight:'400'}}>{datapointDataRaw[0].datapoint + " (Total: " + datapointDataRaw[0].dataElements.length + ")"}</th> : null }
                  { datapointDataRaw && datapointDataRaw[1] ?
                    <th style={{fontWeight:'400'}}>{datapointDataRaw[1].datapoint + " (Total: " + datapointDataRaw[1].dataElements.length + ")"}</th> : null }
                  { datapointDataRaw && datapointDataRaw[2] ?
                    <th style={{fontWeight:'400'}}>{datapointDataRaw[2].datapoint + " (Total: " + datapointDataRaw[2].dataElements.length + ")"}</th> : null }
                  { datapointDataRaw && datapointDataRaw[3] ?
                    <th style={{fontWeight:'400'}}>{datapointDataRaw[3].datapoint + " (Total: " + datapointDataRaw[3].dataElements.length + ")"}</th> : null }
                  { datapointDataRaw && datapointDataRaw[4] ?
                    <th style={{fontWeight:'400'}}>{datapointDataRaw[4].datapoint + " (Total: " + datapointDataRaw[4].dataElements.length + ")"}</th> : null }
                </tr>
              </thead>
              <tbody>
                {datapointData.map(renderData)}
              </tbody>
            </Table>
          </div>
        }


        <Modal show={showDpSelectDialog} onHide={handleFetchDataCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px', maxHeight:'800px'}}>
              <span>
                {t("I18N_Data_fetch_criteria")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Start_time")}: </Col>
                <Col>{t("I18N_End_time")}: </Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <DateTimePicker onChange={onDatepickerChangeStartTime} value={dataFetchAttrs.startTime}
                     format={ (dataFetchAttrs.startTime != null) ? "y-MM-dd hh:mm a" : "y-MM-dd h:mm a" }
/*
                     maxDate={new Date(3600000 * ( Math.round(Date.now() / 3600000)))}
*/
                     disableClock="true"
                     clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                     calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                     locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-CN" : "en")}
                  />
                </Col>
                <Col>
                  <DateTimePicker onChange={onDatepickerChangeEndTime} value={dataFetchAttrs.endTime}
                     format={ (dataFetchAttrs.endTime != null) ? "y-MM-dd hh:mm a" : "y-MM-dd h:mm a" }
/*
                     maxDate={new Date(3600000 * ( Math.round(Date.now() / 3600000)))}
*/
                     disableClock="true"
                     clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                     calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                     locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-CN" : "en")}
                  />
                </Col>
              </Row>

              <div style={{marginTop:'5px'}}>
                <div className={classes.admin_pages__field_label}>{t("I18N_Select_datapoints") + ":"}</div>
                <div style={{height:'100px', overflowY:'scroll', fontSize:'11px', marginTop:'2px', border:'1px solid lightGray'}}>
                  { !selectedDpList || (selectedDpList.length === 0) ?
                    <span style={{padding:'10px'}}> {t("I18N_No_dp_selected")} </span>
                    :
                  <Table hover responsive size="sm">
{/*
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th style={{fontWeight:'400'}}>{t("I18N_Code")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                        <th></th>
                      </tr>
                    </thead>
*/}
                    <tbody>
                      {(selectedDpList && selectedDpList.length > 0) ? selectedDpList.map(renderSelectedDp) : null}
                    </tbody>
                  </Table>
                  }
                </div>
              </div>

              <hr className="solid" style={{ margin: '10px 0 10px 0' }}></hr>

                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Search_datapoint")}</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <Form onSubmit={handleDpSearch}>
                      <Form.Control style={{ fontSize: '12px', height:'22px' }} type="text" name="dpSearchTerms" value={dpSearchTerms}
                                    onChange={(e) => onDpSearchInputChange(e)} placeholder={t("custom:I18N_Eg_search_loc")} />
                    </Form>
                  </Col>
                  <Col>
                    <span onClick={handleDpSearch} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <SearchIcon size={14} />
                    </span>
                  </Col>
                </Row>

                <hr className="solid" style={{ margin: '10px 0 10px 0' }}></hr>

                <div style={{overflowY:'scroll', fontSize:'11px', marginTop:'10px', maxHeight:'300px'}}>
                  <Table hover responsive size="sm">
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th style={{fontWeight:'400'}}>{t("I18N_Code")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(datapointList && datapointList.length > 0) ? datapointList.map(renderDatapoint) : null}
                    </tbody>
                  </Table>
                </div>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsgDpSelectDlg}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleFetchDataCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '10px' }}
                      onClick={handleFetchDataSubmit}>
                      {t("I18N_Fetch_data")}
                    </Button>
                  </div>
                </Row>
            </div>
          </Modal.Body>
        </Modal>
      </Card>

    </Fragment>
  );
}

export default DataInspectAdmin;
